<script>
	export let navigation;
</script>

<nav>
	<div class="nav-container">
		<h1 class="nav-logo">ANDYSAIA</h1>
		<div class="nav-link-container">
			{#each navigation as nav}
				<a
					class="nav-link"
					class:nav-active={nav.isActive}
					href="#{nav.label}">{nav.label}</a
				>
			{/each}
		</div>
	</div>
</nav>

<style>
	nav {
		display: flex;
		justify-content: space-evenly;
		background-color: var(--primary-bg-color);
		position: fixed;
		top: 0;
		width: 100%;
	}

	.nav-container {
		display: flex;
		width: 100%;
		max-width: 1000px;
		padding: 25px;
		height: 60px;
	}

	.nav-link-container {
		flex: content;
		display: flex;
		justify-content: right;
	}

	@media only screen and (max-width: 720px) {
		.nav-link-container {
			display: none;
		}
	}

	.nav-link {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 10px;
		margin: 10px;
		font-size: 38px;
		height: 30px;
		color: var(--secondary-bg-color);
	}

	.nav-active {
		cursor: default;
		background-color: var(--secondary-bg-color);
		color: var(--primary-bg-color) !important;
	}

	.nav-logo {
		font-family: "agencyregular";
		font-size: 77px;
		margin: 0;
		font-weight: normal;
		font-style: normal;
	}

	.nav-link:hover {
		background: var(--secondary-bg-color);
		color: var(--accent-color);
	}
</style>
